import React from "react";
import DownloadIcon from "@dcl/icons/esm/ui/download";
import DownloadPdf from "@dcl/icons/esm/ui/download-pdf";
import getClassNameFactory from "../../utilities/classNames";

var DownloadButton = function DownloadButton(props) {
  var block = props.block,
      children = props.children,
      fileName = props.fileName,
      fileSize = props.fileSize,
      fileType = props.fileType,
      hint = props.hint,
      href = props.href,
      iconLocation = props.iconLocation,
      contentJustify = props.contentJustify,
      newWindow = props.newWindow,
      isPdf = props.isPdf,
      id = props.id,
      renderCustomIcon = props.renderCustomIcon;
  var getClassName = getClassNameFactory(DownloadButton.displayName);
  var linkProps = {
    className: getClassName({
      modifiers: block ? "block" : null
    }),
    download: fileName,
    href: href,
    id: id
  };

  if (newWindow) {
    linkProps.target = "_blank";
    linkProps.rel = "noopener";
  }

  var innerStyleModifier = "".concat(iconLocation || "center", " ").concat(contentJustify || "central");
  var innerCn = getClassName({
    modifiers: innerStyleModifier,
    descendantName: "inner"
  });

  var renderIcon = function renderIcon() {
    return isPdf ? /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        descendantName: "iconPdf"
      })
    }, /*#__PURE__*/React.createElement(DownloadPdf, null)) : /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        descendantName: "icon"
      })
    }, renderCustomIcon ? renderCustomIcon(props) : /*#__PURE__*/React.createElement(DownloadIcon, null));
  };

  return /*#__PURE__*/React.createElement("a", linkProps, /*#__PURE__*/React.createElement("div", {
    className: innerCn
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement("div", null, children), fileType ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "fileInfo"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "fileType"
    })
  }, fileType), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "fileSize"
    })
  }, " - ".concat(fileSize || ""))) : null, hint ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "hint"
    })
  }, /*#__PURE__*/React.createElement("span", null, hint)) : null), renderIcon()));
};

DownloadButton.displayName = "DownloadButton";
export default DownloadButton;